$(".homebanner__downlink").on("click",function() {
	var scrollToSelector = $(this).attr("href"),
		pxAmount = $(scrollToSelector).offset().top;
	scrollToPX(pxAmount);
});